export enum CASE_STUDIES_REFERENCE_CATAGORIES {
  CATEGORIES = 'Categories',
  SUB_CATEGORIES = 'Sub_Categories',
  TAGS = 'Tags',
}
